// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3a99D","image":"Header_image__1wx52","name":"Header_name__-cFjD","info":"Header_info__1zWif","infoRow":"Header_infoRow__2miFP"};